/* eslint-disable no-useless-escape */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/function-component-definition */
/* eslint-disable function-paren-newline */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { ResetPasswordModal } from 'src/components';
import { FullScreenLoading } from 'pg-ui-library';
import { ErrorMessage, Form, Formik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import emailSvg from 'src/assets/email.svg';

import {
  Container,
  FormContainer,
  ImageContainer,
  Input,
  FooterText,
  LinkContainer,
  FooterContainer,
  LogoContainer,
  MenuContainer,
  BackgroundImage,
  FormTitle,
  Logo,
  FooterLink,
  FormInputWrapper,
  InputLabel,
  LoginInput,
  LockIcon,
  QuestionIcon,
  ErrorText,
  ErrorContainer,
  LoginButton,
  ShowPassword,
  AdministratorHeader,
  AdministratorHeaderText,
  EmailIcon,
} from './styles';

import loginImg from '../../assets/login.png';
import logoSvg from '../../assets/logo_pride.svg';
import lockSvg from '../../assets/lock.svg';
import eyeSvg from '../../assets/eye.svg';
import eyeOffSvg from '../../assets/eye-off.svg';
import questionSvg from '../../assets/question.svg';

import { useTypedSelector } from '../../hooks/useTypedSelector';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { ISignin, IValidateUserSignin } from '../../interfaces';
import { useActions } from '../../hooks/useActions';

export const Login: React.FC = () => {
  const [forgotPassIsOpen, setForgotPassIsOpen] = useState<boolean>(false);
  const { data, error, loading } = useTypedSelector(state => state.auth);
  const { signin } = useActions();

  const navigate = useNavigate();
  const [token, setToken] = useLocalStorage('accessToken', null);
  // eslint-disable-next-line no-unused-vars
  const [roles, setRoles] = useLocalStorage('roles', []);
  const location = useLocation();
  const state = location.state as any;
  const from = state?.from?.pathname || '/employee-management';
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<string>('password');
  const [firstIcon, setFirstIcon] = useState<string>(eyeSvg);

  const handlePassword = (visible: string) => {
    setIsVisible(visible === 'password' ? 'text' : 'password');
    setFirstIcon(visible === 'password' ? eyeOffSvg : eyeSvg);
  };

  useEffect(() => {
    if (data?.accessToken) {
      setToken(data.accessToken);
      setRoles(data.permissions);
    }
  }, [data?.accessToken]);

  useEffect(() => {
    if (token) {
      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page.  This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      navigate(from, { replace: true });
    }
  }, [token]);

  const submit = (values: IValidateUserSignin) => {
    signin(values as ISignin);
  };

  const handleForgotPassModal = (isOpen: boolean) => {
    setForgotPassIsOpen(!isOpen);
  };

  const validationSchema = yup.object({
    username: yup.string().required(t('global.form.required')),
    password: yup
      .string()
      .required(t('global.form.required'))
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, 'Invalid password format'),
  });

  return (
    <>
      {loading && <FullScreenLoading />}
      <Container>
        <MenuContainer>
          <AdministratorHeader>
            <AdministratorHeaderText>{t('login.form.adminHeader')}</AdministratorHeaderText>
          </AdministratorHeader>
          <LogoContainer>
            <Logo src={logoSvg} alt="Pride Global logo" />
          </LogoContainer>
          <FormContainer>
            <FormTitle>{t('login.form.title')}</FormTitle>
            <Formik
              initialValues={{
                username: '',
                password: '',
              }}
              onSubmit={submit}
              validationSchema={validationSchema}
            >
              {({ handleChange, handleSubmit, errors }) => (
                <Form onSubmit={handleSubmit}>
                  <FormInputWrapper>
                    <InputLabel>{t('login.form.email')}</InputLabel>
                    <LoginInput>
                      <EmailIcon src={emailSvg} />
                      <Input
                        id="username"
                        name="username"
                        type="text"
                        placeholder={t('login.form.email')}
                        onChange={handleChange}
                      />
                    </LoginInput>
                  </FormInputWrapper>
                  <FormInputWrapper>
                    <InputLabel>{t('login.form.password')}</InputLabel>
                    <LoginInput>
                      <LockIcon src={lockSvg} />
                      <Input
                        id="password"
                        name="password"
                        type={isVisible}
                        placeholder={t('login.form.password')}
                        onChange={handleChange}
                      />
                      <ShowPassword src={firstIcon} onClick={() => handlePassword(isVisible)} />
                      <div data-cy="question-icon" title={t('login.form.forgotPassword')}>
                        <QuestionIcon src={questionSvg} onClick={() => handleForgotPassModal(forgotPassIsOpen)} />
                      </div>
                    </LoginInput>
                  </FormInputWrapper>
                  <ResetPasswordModal isOpen={forgotPassIsOpen} />
                  <ErrorContainer>
                    {error ? (
                      <ErrorText>{t('login.form.error')}</ErrorText>
                    ) : (
                      <ErrorMessage name={errors.username ? 'username' : 'password'} component={ErrorText} />
                    )}
                  </ErrorContainer>
                  <LoginButton type="submit">{t('login.form.button')}</LoginButton>
                </Form>
              )}
            </Formik>
          </FormContainer>
          <FooterContainer>
            <FooterText>{t('signUp.footer.rights')}</FooterText>
            <LinkContainer>
              <FooterLink href="/">{t('login.footer.termsOfUse')}</FooterLink>
              <FooterLink href="/">{t('login.footer.privacyPolicy')}</FooterLink>
              <FooterLink href="mailto:employeesupport@prideglobal.com" target="_blank">
                {t('login.footer.support')}
              </FooterLink>
            </LinkContainer>
          </FooterContainer>
        </MenuContainer>
        <ImageContainer>
          <BackgroundImage src={loginImg} alt="Background image" />
        </ImageContainer>
      </Container>
    </>
  );
};

export default function LoginPageWrapper() {
  return <Login />;
}
